import { EvaluationParametersFields } from '../../../TabEvaluations/components/EvaluationParametersFields';
import type { IProfessorAreaEvaluationsList } from 'interfaces/professor_area/evaluations';

interface ModalCreateAssignmentStep3Props {
  classroomEvaluations: IProfessorAreaEvaluationsList[];
  evaluationsLoading: boolean;
}

export const ModalCreateAssignmentStep3 = ({
  classroomEvaluations,
  evaluationsLoading
}: ModalCreateAssignmentStep3Props) => (
  <EvaluationParametersFields
    entity="assignment"
    classroomEvaluations={classroomEvaluations}
    evaluationsLoading={evaluationsLoading}
  />
);
